import axios from "axios";
import { Message } from "element-ui";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    // config.headers['X-Requested-With'] = 'XMLHttpRequest'
    // config.headers['Content-Type'] = 'application/json'
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0 && res.code !== 200) {
      Message({
        message: res.msg || "数据请求失败，请稍后重试",
        type: "error",
        duration: 3 * 1000,
      });

      if (res.code === 202 || res.code === 201) {
        // to re-login
        window.location.href = "login";
      }
      return Promise.reject(new Error(res.msg || "数据请求失败，请稍后重试"));
    } else {
      return response;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    Message({
      message: error.msg || "数据请求失败，请稍后重试",
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
